import { MenuState } from 'types/info/user';

export const MenuInitialState: MenuState = {
  fetchUserMenu: {
    isLoadMenuSuccess: false,
    rawMenu: [],
  },
};
